import { registerWidget } from "$json/lib/form-widgets";
import { wControl } from "$json/lib/control";
import { _ } from "$json/lib/gettext";
import { navigateInlineTo } from "$json/lib/utils/keyboard.js";
import { eventKey } from "$json/lib/utils/keys.js";
/* grids:
 *
 * Register grid type 'grid-tabs' when metatadata.grid-tabs is present, or when
 * (legacy) font-class reads 'grid_tabs'.
 *
 * Author: Niels Giesen
 * Copyright 2012, 2014 Berkeley Bridge
 *
 */
(function ($, doc, win) {
  $(function () {
    $(document).on("bb:preHandleData", function (event, data, status, req) {
      if (typeof data != "undefined" && data && data.groups)
        data.groups = $.map(data.groups, function (group) {
          group.controls = $.map(group.controls, function (control) {
            if (
              (control.controltype === "grid" &&
                control["font-class"] === "grid_tabs") ||
              (control["metadata"] && control["metadata"]["p-grid-tabs"])
            ) {
              control.controltype = "grid-tabs";
            }
            return control;
          });
          return group;
        });
    });
  });

  const navigationFn = navigateInlineTo(".tab");

  var render = function (control, widget, group) {
    let tabs = document.createElement("div");
    tabs.role = "tablist";
    tabs.classList.add("tabs");
    tabs.addEventListener("keydown", navigationFn);
    var labelidx,
      i = 0,
      sel_idx = 0,
      sel_tab;
    while (labelidx === undefined && control.columns[i]) {
      var controltype = control.columns[i].controltype;
      if (controltype !== "checkbox" && controltype !== "radiobutton") {
        labelidx = i;
      }
      i++;
      if (labelidx >= control.columns.length) break;
    }
    if (typeof labelidx === "undefined") labelidx = 0;
    control.value.forEach(function (row, i) {
      const tab = document.createElement("div");
      tab.role = "tab";
      tab.id = "tab-" + control.id + "-" + i;
      tab.setAttribute("aria-controls", "tabpanel-" + control.id + "-" + i);
      tab.tabIndex = -1;
      tab.classList.add("tab", "tab-" + i);
      tab.dataset["idx"] = i;
      const span = document.createElement("span");
      span.textContent = row[labelidx].value;
      tab.append(span);
      if (group.current && control.deleteallowed) {
        const deletebutton = document.createElement("button");
        deletebutton.tabIndex = -1;
        deletebutton.classList.add("delete-x");
        deletebutton.name = "update";
        deletebutton.value = control.name + "." + i + "." + "-";
        const symbol = document.createElement("span");
        symbol.textContent = "×";
        symbol.ariaHidden = true;
        deletebutton.append(symbol);
        const text = document.createElement("span");
        text.textContent = "Remove this item with DELETE";
        text.classList.add("a-offscreen");
        deletebutton.append(text);
        tab.append(deletebutton);
      }
      if (!sel_idx && row[labelidx].value === "") {
        sel_idx = i;
        tab.querySelector("span").textContent = "(" + _("new") + ")";
        sel_tab = tab;
        tab.ariaSelected = true;
        tab.tabIndex = 0;
      } else tabs.append(tab);
    });
    if (sel_tab) tabs.append(sel_tab);
    if (group.current && control.addallowed) {
      const addbutton = document.createElement("button");
      addbutton.tabIndex = 0;
      addbutton.classList.add("add");
      addbutton.name = "update";
      addbutton.value =
        control.name + encodeURI("." + control.value.length + ".+");
      const symbol = document.createElement("span");
      symbol.textContent = "+";
      symbol.ariaHidden = true;
      addbutton.append(symbol);
      const text = document.createElement("span");
      text.textContent = "Add an item";
      text.classList.add("a-offscreen");
      addbutton.append(text);
      const tabPlus = document.createElement("div");
      tabPlus.classList.add("tab_plus");
      tabPlus.append(addbutton);
      tabs.append(tabPlus);
    }
    widget.append(tabs);
    control.value.forEach(function (row, i) {
      const card = document.createElement("table");
      card.id = "tabpanel-" + control.id + "-" + i;
      card.setAttribute("aria-labelledby", "tab-" + control.id + "-" + i);
      card.classList.add("card", "card-" + i);
      card.role = "tabpanel";
      card.dataset["idx"] = i;
      card.hidden = true;
      if (sel_idx === i) {
        card.classList.add("selected");
        card.hidden = false;
      }
      widget.append(card);
      //      $(tabs.querySelector(".tab-" + i)).data("card", card);
      row.forEach(function (cell, ii) {
        const rowElt = document.createElement("tr"),
          cellElt = document.createElement("td");
        card.append(rowElt);
        const labelCell = document.createElement("td");
        const labelElt = document.createElement("label");
        labelElt.for = control.id + "-" + i + "-" + ii;
        if (control.columns[ii].notnull)
          labelElt.classList.add("bb-for-required");
        labelElt.textContent = control.columns[ii].colname || "";
        labelCell.append(labelElt);
        rowElt.append(labelCell);
        rowElt.append(cellElt);
        var column = control.columns[ii];
        wControl(
          $.extend(
            column,
            { id: control.id + "-" + i + "-" + ii },
            $.isPlainObject(cell) ? cell : { value: cell }
          ),
          group,
          cellElt //append hereto
        );
      });
    });
    widget.find(".tab-" + sel_idx).addClass("selected");
    widget
      .find(".card tr:nth-child(" + labelidx + 1 + ") input")
      .on("change", function () {
        var idx = $(this).parents(".card").data("idx");
        $(this)
          .parents("*[data-type=grid-tabs]")
          .find(".tab-" + idx)
          .find("span")
          .text($(this).val());
      });
  };

  const onSelect = function (event) {
    const tab = event.target.closest(".tab");
    if (!tab) return;
    const idx = tab.dataset["idx"];
    const container = tab.closest('[data-type="grid-tabs"]');
    for (let card_or_tab of container.querySelectorAll(".card, .tab")) {
      if (card_or_tab.dataset["idx"] === idx) {
        if (card_or_tab.matches(".tab")) {
          card_or_tab.ariaSelected = true;
          card_or_tab.tabIndex = 0;
        } else {
          card_or_tab.hidden = false;
        }
        card_or_tab.classList.add("selected");
      } else {
        card_or_tab.classList.remove("selected");
        if (card_or_tab.matches(".tab")) {
          card_or_tab.tabIndex = -1;
        } else {
          card_or_tab.hidden = true;
        }
      }
    }
  };

  document.addEventListener("click", onSelect);
  document.addEventListener("keydown", function (event) {
    if (
      ["Enter", "Space"].includes(eventKey(event)) &&
      event.target.matches(".tab")
    ) {
      onSelect(event);
      return;
    }
    if (
      ["Delete", "Backspace"].includes(eventKey(event)) &&
      event.target.matches(".tab")
    ) {
      const deletebutton = event.target.querySelector(".delete-x");
      deletebutton && deletebutton.click();
      return;
    }
  });

  document.addEventListener("focus", function (event) {
    const tab = event.target;
    if (!("matches" in tab)) return;
    if (!tab.matches(".tab")) return;
  });

  registerWidget({
    name: "grid-tabs",
    tagName: "div",
    attribs: () => ({}),
    render: render
  });
})(jQuery, document, window);
